module.exports = __webpack_public_path__ + "static/media/Ellipse-small.b853466e.png";